<div class="po-xl-6 po-lg-6 po-md-12 po-sm-12 top-selling" id="top-selling">
  <po-widget>
    <div class="po-row">
      <div class="po-xl-7 po-lg-7 po-md-7 po-sm-7 po-pt-0 po-pl-0">
        <span class="po-font-text-bold">Top 10 mais vendidos</span>
        <span class="po-ml-1 po-icon po-icon-exclamation" [p-tooltip]="topTooltip"></span>
        <span class="po-ml-1 po-icon po-icon-xml pointer-cursor" [p-tooltip]="topTooltipExcel" (click)="downloadExcel()"></span>
      </div>
      <div class="po-xl-5 po-lg-5 po-md-5 po-sm-5">
        <po-select name="select" (ngModelChange)="saveFilter($event)" [p-options]="listProduct" (p-change)="recoverProduct($event)" [p-placeholder]="filterPlaceholder" [ngModel]="typeSelected"></po-select>
      </div>
      <div class="icon-loading" *ngIf="loading && !errorApi">
        <app-loading-icon></app-loading-icon>
      </div>
      <div class="po-md-12 po-text-center" *ngIf="!loading && errorApi">
        <app-error [message]="message"></app-error>
      </div>
    </div>
    <div *ngIf="!loading && !errorApi">
      <fusioncharts [width]="width" [height]="height" [type]="type" [dataFormat]="dataFormat" [dataSource]="dataSource">
      </fusioncharts>
    </div>
    <div class="po-xl-12 po-lg-12 po-md-12 po-sm-12 po-text-center po-pt-2 more-details po-clickable"
      (click)="goToTopSelling()" *ngIf="!loading && !errorApi">
      <span>+ Detalhes</span>
    </div>
  </po-widget>
</div>
